// /* eslint-disable react-hooks/exhaustive-deps */
// import React, { memo, useEffect, useRef, useState } from "react";
// import shoHideMenu from "../../assets/svg/icon-menu-navbar.svg";
// import itemsSidebar from "../../assets/js/itemsSidebar";
// import { useLocation, useNavigate } from "react-router-dom";
// import { setBusiness } from "../../store/actions/businessAction";
// import { IconButton } from "@mui/material";
// import ChevronIcon from "assets/icons/ChevronIcon";
// import BasicCollapse from "components/Shared/BasicCollapse";
// import { appSetExpandedSidebar } from "store/actions/appAction";
// import { apiGetFiscalYear } from "api/appApi";
// import { SearchIcon2 } from "assets/icons/SearchIcon";
// import MenuButton from "./MenuButton";
// import "../../assets/styles/components/sidebarPermission.scss";
// import ShopCart from "assets/icons/ShopCartIcon";
// import SettingsIcon from "assets/icons/SettingsIcon";
// import BasicButton from "components/BasicInputs/BasicButton";
// import { Add, AddCircleOutline } from "@mui/icons-material";
// import { store, useAppDispatch, useAppSelector } from "store/store";
// import { checkUserAccess } from "helpers/helper";
// import { apiGetRoles } from "api/roleApi";

// const moment = require("moment-jalaali");

// const useOutsideClick = (callback: { (): void; (): void }) => {
//   const ref = React.useRef();

//   React.useEffect(() => {
//     const handleClick = (event: any) => {
//       //@ts-ignore
//       if (ref.current && !ref.current.contains(event.target)) {
//         callback();
//       }
//     };

//     document.addEventListener("click", handleClick, true);

//     return () => {
//       document.removeEventListener("click", handleClick, true);
//     };
//   }, [ref]);

//   return ref;
// };

// function Sidebar() {
//   /* ---------------------------------- Hooks --------------------------------- */
//   let location = useLocation();
//   const business = useAppSelector((x: any) => x.businessReducer.business);
//   const sidebarExpanded = useAppSelector((x: any) => x.appReducer.sidebarExpanded);
//   const f = useAppSelector((x: any) => x.appReducer.fiscalYears);
//   const fiscalYear = useAppSelector((x: any) => x.appReducer.fiscalYear) || {};
//   const token = useAppSelector((x: any) => x.businessReducer.business?.token);
//   const [state, setState] = useState({ expand: sidebarExpanded });
//   const [renderItems, setRenderItems] = useState(itemsSidebar.items);
//   const [showPhone, setShowPhone] = useState(false);
//   const [showItemMenu, setShowItemMenu] = useState();
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();
//   const searchInputRef = useRef(null);

//   /* -------------------------------- Variables ------------------------------- */
//   const classes = ["wrap-sidebar-premission", state.expand ? "expand" : ""];

//   const roles = store.getState().roleReducer?.roles;

//   const conditions = {
//     haveWarehouse: business?.business?.haveWarehouse ?? true,
//     isAdmin: business?.user?.email && business?.user?.email === "support@chortke.app",
//     hasSmsPanel:
//       business?.business?.subscription && ![7, 10, 13, 17].includes(business?.business?.subscription.id),
//   };



//   useEffect(() => {
//     if (!roles?.length) {
//       dispatch(apiGetRoles(token));
//     }
//   }, [token]);
//   useEffect(() => {
//     setState({ expand: sidebarExpanded });
//   }, [sidebarExpanded]);

//   /* -------------------------------- Functions ------------------------------- */

//   function searchSidebar(text: string) {
//     if (text === "") return setRenderItems(itemsSidebar.items);
//     const filteredItems = itemsSidebar.items.flatMap((x) => {
//       const itemExist = x.name.includes(text);
//       if (itemExist) return x;
//       const item = { ...x };
//       const sub: any[] = item.subItem ? [...item.subItem] : [];
//       const subs = sub.filter((y) => y.name.includes(text));
//       if (subs.length > 0) {
//         item.subItem = [...subs];
//         return item;
//       }
//       return [];
//     });
//     setRenderItems(filteredItems);
//   }

//   function handleFiscalYearChange(value: number) {
//     // @ts-ignore
//     dispatch(apiGetFiscalYear(value));
//   }

//   function expandSidebar(open?: boolean) {
//     const expand = open ? true : !state.expand;
//     setState((x) => ({ ...x, expand }));
//     dispatch(appSetExpandedSidebar(expand));
//   }

//   const handleClickOutside = () => {
//     setShowPhone(false);
//   };

//   const ref = useOutsideClick(handleClickOutside);

//   const displaySubscription = () => {
//     const now: any = new Date();
//     const date = moment(business.business.expirationAt, "jYYYY/jM/jD").format("YYYY-M-D");

//     const difference = Math.floor((Date.parse(date) - Date.parse(now)) / 86400000);
//     const text = ` روز مانده از اشتراک ${business.business.subscriptionTitle}`;
//     return { difference, text };
//   };

//   /* ----------------------------------- JSX ---------------------------------- */
//   return (
//     <>
//       {business?.business && (
//         <div id="main-sidebar" className={classes.join(" ")}>
//           <IconButton
//             style={{
//               backgroundColor: !state.expand ? "#1062D0" : "#fff",
//               boxShadow: "0px 0px 12px rgba(54, 66, 82, 0.23)",
//               width: 28,
//               height: 28,
//               position: "absolute",
//               left: -14,
//               top: 85,
//               zIndex: 10,
//               transition: "all 300ms ease-in-out",
//             }}
//             onClick={() => expandSidebar()}
//           >
//             <ChevronIcon
//               color={state.expand ? "#1062D0" : "#fff"}
//               style={{
//                 position: "relative",
//                 transform: `scale(1.5) rotate(${!state.expand ? "90deg" : "270deg"})`,
//               }}
//             />
//           </IconButton>
//           <button
//             //@ts-ignore
//             ref={ref}
//             // onMouseOver={()=>{console.log('over')}}
//             onMouseLeave={() => setShowPhone(false)}
//             style={{
//               backgroundColor: "#1062D0",
//               boxShadow: "0px 0px 12px rgba(54, 66, 82, 0.23)",
//               width: showPhone ? 110 : 40,
//               height: 40,
//               position: "absolute",
//               left: showPhone ? -110 : -40,
//               bottom: 22,
//               zIndex: 1000,
//               paddingLeft: "8px",
//               paddingRight: "8px",
//               // transition: "all 300ms ease-in-out",
//               borderTopLeftRadius: "16px",
//               borderBottomLeftRadius: "16px",
//               alignItems: "center",
//               justifyContent: "center",
//               display: "flex",
//             }}
//             onClick={() => {
//               setShowPhone(!showPhone);
//             }}
//           >
//             {showPhone && (
//               <a href="tel:02152127">
//                 <div className="ml-1 text-white">021-52127</div>
//               </a>
//             )}
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 flexDirection: "row",
//               }}
//             >
//               <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <path
//                   d="m4.76 3.662.138-.135a2 2 0 0 1 2.706 0c.031.029.067.064.137.135L9.2 5.12a2.759 2.759 0 0 1 .578 3.053 2.759 2.759 0 0 0 .578 3.053l2.397 2.397a2.758 2.758 0 0 0 3.053.578 2.759 2.759 0 0 1 3.053.578l1.458 1.459c.07.07.106.106.135.137a2 2 0 0 1 0 2.706c-.029.031-.064.067-.135.137l-.886.887a2.985 2.985 0 0 1-2.759.803 17.913 17.913 0 0 1-13.6-13.601 2.986 2.986 0 0 1 .803-2.759l.886-.886Z"
//                   stroke="#FEFEFE"
//                   strokeWidth="1.5"
//                 />
//               </svg>
//             </div>
//           </button>

//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 16,
//               padding: 12,
//               whiteSpace: "nowrap",
//               overflow: "hidden",
//             }}
//           >
//             <MenuButton
//               title={business.business.nickName}
//               extraStyle={{ borderColor: "transparent" }}
//               origin={{ img: shoHideMenu, color: "#747575" }}
//               hover={{
//                 bgColor: "transparent",
//                 color: "#747575",
//                 img: shoHideMenu,
//               }}
//               expand={state.expand}
//               onOpen={() => expandSidebar(true)}
//               items={[
//                 {
//                   name: displaySubscription().text,
//                   id: "days",
//                   Icon: <span className="text-blue-1">{displaySubscription().difference}</span>,
//                 },
//                 {
//                   name: "تمدید اشتراک",
//                   id: "renew",
//                   url: "/business/extend",
//                   Icon: <ShopCart color="#1062D0" />,
//                 },
//                 {
//                   name: "مدیریت کسب و کارها",
//                   id: "settings",
//                   url: "/",
//                   Icon: <SettingsIcon color="#1062D0" scale={0.8} />,
//                 },
//               ]}
//               onItemClick={(item) => {
//                 const bs: any = {
//                   settings: null,
//                   renew: business,
//                 };
//                 if (["settings", "renew"].includes(item.id)) {
//                   dispatch(setBusiness(bs[item.id]));
//                 }
//               }}
//             />
//             {state.expand && (
//               <div>
//                 <BasicCollapse
//                   title={"تغییر سال مالی"}
//                   defaultValue={fiscalYear.id}
//                   items={f ? f.map((x: any) => ({ title: x.name, value: x.id })) : []}
//                   onChange={handleFiscalYearChange}
//                 />
//               </div>
//             )}
//             <BasicButton
//               onClick={() => navigate("factors/add")}
//               variant="contained"
//               className={`min-w-[40px] transition-none ${!state.expand && "w-10"}`}
//             >
//               <AddCircleOutline />
//               {state.expand && <span>ثبت فاکتور</span>}
//             </BasicButton>
//             <MenuButton
//               icon={<SearchIcon2 color="#aeaeae" scale={1.2} />}
//               extraStyle={{ borderColor: "#aeaeae" }}
//               expand={state.expand}
//               onClick={() => {
//                 expandSidebar(true);
//                 const r: any = searchInputRef.current;
//                 r && r.focus();
//               }}
//               children={
//                 <input
//                   ref={searchInputRef}
//                   onChange={(e) => searchSidebar(e.target.value)}
//                   style={{
//                     width: "100%",
//                     border: 0,
//                     outline: 0,
//                     background: "transparent",
//                   }}
//                 />
//               }
//             />
//           </div>
//           <div
//             className={`flex flex-col gap-2 p-3 overflow-hidden hover:overflow-y-auto h-[calc(100vh-300px)] ${state.expand && "scroll-gutter"
//               }`}
//           >
//             {renderItems.map((item: any, index: any) => {
//               if (item.condition && !(conditions as any)[item.condition]) return <></>;
//               const isSearching = renderItems.length !== itemsSidebar.items.length;
//               const s: any = item.subItem;
//               const activeSub = s && Array.isArray(s) && s.find((x: any) => x.url === location.pathname);
//               const matchPath = item.url === location.pathname || !!activeSub;
//               let subItems = item?.subItem?.map((x: any) => {
//                 if (x.condition && !(conditions as any)[x.condition]) return false;
//                 // if (x.permission && Accesses.includes(x.permission)) return false;
//                 if (checkUserAccess({ checkUserAction: x.permission ? x.permission : '' }))
//                   return { ...x, active: x.id === activeSub?.id };
//                 else return false
//               }).filter((r: any) => r !== false)

//               let isActive = isSearching;
//               if (showItemMenu === item.id) isActive = true;
//               else if (matchPath && showItemMenu === undefined) isActive = true;
//               return (
//                 <MenuButton
//                   key={index}
//                   title={item.name}
//                   item={item}
//                   expand={state.expand}
//                   items={subItems}
//                   onclick={() => {
//                     if (item.url) navigate(item.url);
//                     if (item.link) window.open(item.link + `/${token}`, "_blank");
//                   }}
//                   onItemClick={(x) => navigate(x.url)}
//                   onOpen={(item: any) => {
//                     expandSidebar(true);
//                     setShowItemMenu(item.id);
//                   }}
//                   extraStyle={{ color: "#424242", border: 0, gap: 24 }}
//                   origin={{
//                     color: "rgb(123, 123, 123)",
//                     bgColor: "transparent",
//                     img: item.img,
//                   }}
//                   hover={{
//                     color: "#fff",
//                     bgColor: "#1062D0",
//                     img: item.imgHover,
//                   }}
//                   open={{
//                     color: "#1062D0",
//                     bgColor: "transparent",
//                     img: item.imgActive,
//                     open: isActive,
//                   }}
//                 />
//               );
//             })}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// export default memo(Sidebar);
/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useRef, useState } from "react";
import shoHideMenu from "../../assets/svg/icon-menu-navbar.svg";
import itemsSidebar from "../../assets/js/itemsSidebar";
import { useLocation, useNavigate } from "react-router-dom";
import { setBusiness } from "../../store/actions/businessAction";
import { IconButton } from "@mui/material";
import ChevronIcon from "assets/icons/ChevronIcon";
import BasicCollapse from "components/Shared/BasicCollapse";
import { appSetExpandedSidebar } from "store/actions/appAction";
import { apiGetFiscalYear } from "api/appApi";
import { SearchIcon2 } from "assets/icons/SearchIcon";
import MenuButton from "./MenuButton";
import "../../assets/styles/components/sidebarPermission.scss";
import ShopCart from "assets/icons/ShopCartIcon";
import SettingsIcon from "assets/icons/SettingsIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import { AddCircleOutline } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "store/store";
import { checkUserAccess } from "helpers/helper";

const moment = require("moment-jalaali");

const useOutsideClick = (callback: { (): void; (): void }) => {
  const ref = React.useRef();

  React.useEffect(() => {
    const handleClick = (event: any) => {
      //@ts-ignore
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [ref]);

  return ref;
};

function Sidebar() {
  /* ---------------------------------- Hooks --------------------------------- */
  let location = useLocation();
  const business = useAppSelector((x: any) => x.businessReducer.business);
  const sidebarExpanded = useAppSelector((x: any) => x.appReducer.sidebarExpanded);
  const f = useAppSelector((x: any) => x.appReducer.fiscalYears);
  const fiscalYear = useAppSelector((x: any) => x.appReducer.fiscalYear) || {};
  const token = useAppSelector((x: any) => x.businessReducer.business?.token);
  const [state, setState] = useState({ expand: sidebarExpanded });
  const [renderItems, setRenderItems] = useState(itemsSidebar.items);
  const [showPhone, setShowPhone] = useState(false);
  const [showItemMenu, setShowItemMenu] = useState();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const searchInputRef = useRef(null);

  /* -------------------------------- Variables ------------------------------- */
  const classes = ["wrap-sidebar-premission", state.expand ? "expand" : ""];
  // const fiscalYears = f ? f.map((x: any) => ({ title: x.name, value: x.id })) : [];

  const user = business?.user;
  const Accesses = user?.Roles[0]?.Accesses?.map((x: any) => x.en_title) || [];

  const conditions = {
    haveWarehouse: business?.business?.haveWarehouse ?? true,
    isAdmin: business?.user?.email && business?.user?.email === "support@chortke.app",
    hasSmsPanel:
      business?.business?.subscription && ![7, 10, 13, 17].includes(business?.business?.subscription.id),
  };

  /* --------------------------------- Effects -------------------------------- */
  // @ts-ignore
  // useEffect(() => dispatch(apiGetFiscalYears()), [token]);

  useEffect(() => {
    setState({ expand: sidebarExpanded });
  }, [sidebarExpanded]);

  /* -------------------------------- Functions ------------------------------- */

  function searchSidebar(text: string) {
    if (text === "") return setRenderItems(itemsSidebar.items);
    const filteredItems = itemsSidebar.items.flatMap((x) => {
      const itemExist = x.name.includes(text);
      if (itemExist) return x;
      const item = { ...x };
      const sub: any[] = item.subItem ? [...item.subItem] : [];
      const subs = sub.filter((y) => y.name.includes(text));
      if (subs.length > 0) {
        item.subItem = [...subs];
        return item;
      }
      return [];
    });
    setRenderItems(filteredItems);
  }

  function handleFiscalYearChange(value: number) {
    // @ts-ignore
    dispatch(apiGetFiscalYear(value));
  }

  function expandSidebar(open?: boolean) {
    const expand = open ? true : !state.expand;
    setState((x) => ({ ...x, expand }));
    dispatch(appSetExpandedSidebar(expand));
  }

  const handleClickOutside = () => {
    setShowPhone(false);
  };

  const ref = useOutsideClick(handleClickOutside);

  const displaySubscription = () => {
    const now: any = new Date();
    const date = moment(business.business.expirationAt, "jYYYY/jM/jD").format("YYYY-M-D");

    const difference = Math.floor((Date.parse(date) - Date.parse(now)) / 86400000);
    const text = ` روز مانده از اشتراک ${business.business.subscriptionTitle}`;
    return { difference, text };
  };

  /* ----------------------------------- JSX ---------------------------------- */
  return (
    <>
      {business?.business && (
        <div id="main-sidebar" className={classes.join(" ")}>
          <IconButton
            style={{
              backgroundColor: !state.expand ? "#1062D0" : "#fff",
              boxShadow: "0px 0px 12px rgba(54, 66, 82, 0.23)",
              width: 28,
              height: 28,
              position: "absolute",
              left: -14,
              top: 85,
              zIndex: 10,
              transition: "all 300ms ease-in-out",
            }}
            onClick={() => expandSidebar()}
          >
            <ChevronIcon
              color={state.expand ? "#1062D0" : "#fff"}
              style={{
                position: "relative",
                transform: `scale(1.5) rotate(${!state.expand ? "90deg" : "270deg"})`,
              }}
            />
          </IconButton>
          <button
            //@ts-ignore
            ref={ref}
            // onMouseOver={()=>{console.log('over')}}
            onMouseLeave={() => setShowPhone(false)}
            style={{
              backgroundColor: "#1062D0",
              boxShadow: "0px 0px 12px rgba(54, 66, 82, 0.23)",
              width: showPhone ? 110 : 40,
              height: 40,
              position: "absolute",
              left: showPhone ? -110 : -40,
              bottom: 22,
              zIndex: 1000,
              paddingLeft: "8px",
              paddingRight: "8px",
              // transition: "all 300ms ease-in-out",
              borderTopLeftRadius: "16px",
              borderBottomLeftRadius: "16px",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
            onClick={() => {
              setShowPhone(!showPhone);
            }}
          >
            {showPhone && (
              <a href="tel:02152127">
                <div className="ml-1 text-white">021-52127</div>
              </a>
            )}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m4.76 3.662.138-.135a2 2 0 0 1 2.706 0c.031.029.067.064.137.135L9.2 5.12a2.759 2.759 0 0 1 .578 3.053 2.759 2.759 0 0 0 .578 3.053l2.397 2.397a2.758 2.758 0 0 0 3.053.578 2.759 2.759 0 0 1 3.053.578l1.458 1.459c.07.07.106.106.135.137a2 2 0 0 1 0 2.706c-.029.031-.064.067-.135.137l-.886.887a2.985 2.985 0 0 1-2.759.803 17.913 17.913 0 0 1-13.6-13.601 2.986 2.986 0 0 1 .803-2.759l.886-.886Z"
                  stroke="#FEFEFE"
                  stroke-width="1.5"
                />
              </svg>
            </div>
          </button>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 16,
              padding: 12,
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            <MenuButton
              title={business.business.nickName}
              extraStyle={{ borderColor: "transparent" }}
              origin={{ img: shoHideMenu, color: "#747575" }}
              hover={{
                bgColor: "transparent",
                color: "#747575",
                img: shoHideMenu,
              }}
              expand={state.expand}
              onOpen={() => expandSidebar(true)}
              items={[
                {
                  name: displaySubscription().text,
                  id: "days",
                  Icon: <span className="text-blue-1">{displaySubscription().difference}</span>,
                },
                {
                  name: "تمدید اشتراک",
                  id: "renew",
                  url: "/business/extend",
                  Icon: <ShopCart color="#1062D0" />,
                },
                {
                  name: "مدیریت کسب و کارها",
                  id: "settings",
                  url: "/",
                  Icon: <SettingsIcon color="#1062D0" scale={0.8} />,
                },
              ]}
              onItemClick={(item) => {
                const bs: any = {
                  settings: null,
                  renew: business,
                };
                if (["settings", "renew"].includes(item.id)) {
                  dispatch(setBusiness(bs[item.id]));
                }
              }}
            />
            {state.expand && (
              <div>
                <BasicCollapse
                  title={"تغییر سال مالی"}
                  defaultValue={fiscalYear.id}
                  items={f ? f.map((x: any) => ({ title: x.name, value: x.id })) : []}
                  onChange={handleFiscalYearChange}
                />
              </div>
            )}
            <BasicButton
              onClick={() => navigate("factors/add")}
              variant="contained"
              className={`min-w-[40px] transition-none ${!state.expand && "w-10"}`}
            >
              <AddCircleOutline />
              {state.expand && <span>ثبت فاکتور</span>}
            </BasicButton>
            <MenuButton
              icon={<SearchIcon2 color="#aeaeae" scale={1.2} />}
              extraStyle={{ borderColor: "#aeaeae" }}
              expand={state.expand}
              onClick={() => {
                expandSidebar(true);
                const r: any = searchInputRef.current;
                r && r.focus();
              }}
              children={
                <input
                  ref={searchInputRef}
                  onChange={(e) => searchSidebar(e.target.value)}
                  style={{
                    width: "100%",
                    border: 0,
                    outline: 0,
                    background: "transparent",
                  }}
                />
              }
            />
          </div>
          <div
            className={`flex flex-col gap-2 p-3 overflow-hidden hover:overflow-y-auto h-[calc(100vh-300px)] ${state.expand && "scroll-gutter"
              }`}
          >
            {/* {renderItems.map((item: any, index: any) => {
              if (item.condition && !(conditions as any)[item.condition]) return <></>;
              if (item.permission && Accesses.includes(item.permission)) return <></>;

              const isSearching = renderItems.length !== itemsSidebar.items.length;
              const s: any = item.subItem;
              const activeSub = s && Array.isArray(s) && s.find((x: any) => x.url === location.pathname);
              const matchPath = item.url === location.pathname || !!activeSub;
              let subItems = item?.subItem?.map((x: any) => {
                if (x.condition && !(conditions as any)[x.condition]) return false;
                // if (x.permission && Accesses.includes(x.permission)) return false;
                return { ...x, active: x.id === activeSub?.id };
              });

              let isActive = isSearching;
              if (showItemMenu === item.id) isActive = true;
              else if (matchPath && showItemMenu === undefined) isActive = true;
              return (
                <MenuButton
                  key={index}
                  title={item.name}
                  item={item}
                  expand={state.expand}
                  items={subItems}
                  onclick={() => {
                    if (item.url) navigate(item.url);
                    if (item.link) window.open(item.link + `/${token}`, "_blank");
                  }}
                  onItemClick={(x) => navigate(x.url)}
                  onOpen={(item: any) => {
                    expandSidebar(true);
                    setShowItemMenu(item.id);
                  }}
                  extraStyle={{ color: "#424242", border: 0, gap: 24 }}
                  origin={{
                    color: "rgb(123, 123, 123)",
                    bgColor: "transparent",
                    img: item.img,
                  }}
                  hover={{
                    color: "#fff",
                    bgColor: "#1062D0",
                    img: item.imgHover,
                  }}
                  open={{
                    color: "#1062D0",
                    bgColor: "transparent",
                    img: item.imgActive,
                    open: isActive,
                  }}
                />
              );
            })} */}
            {renderItems.map((item: any, index: any) => {
              if (item.condition && !(conditions as any)[item.condition]) return <></>;
              if (item.permission && !checkUserAccess({ checkUserAction: item.permission, checkBussinesAccess: item?.businessAccess })) return <></>;
              const isSearching = renderItems.length !== itemsSidebar.items.length;
              const hasSubItem = typeof item.subItem !== "undefined"
              const s: any = item.subItem || [];
              const activeSub = s && Array.isArray(s) && s.find((x: any) => x.url === location.pathname);
              const matchPath = item.url === location.pathname || !!activeSub;
              let subItems = s?.map((x: any) => {
                if (x.condition && !(conditions as any)[x.condition]) return false;
                if (x.permission && !checkUserAccess({ checkUserAction: x.permission, checkBussinesAccess: x?.businessAccess })) return false
                // if (x.permission && Accesses.includes(x.permission)) return false;
                return { ...x, active: x.id === activeSub?.id };
              }).filter((r: any) => typeof r !== "boolean");
              let isActive = isSearching;
              if (showItemMenu === item.id) isActive = true;
              else if (matchPath && showItemMenu === undefined) isActive = true;
              else if (hasSubItem && subItems.filter((r: any) => r.name !== "slot").length === 0) return <></>
              return (
                <MenuButton
                  key={index}
                  title={item.name}
                  item={item}
                  expand={state.expand}
                  items={subItems?.length ? subItems : undefined}
                  onclick={() => {
                    if (item.url) navigate(item.url);
                    if (item.link) window.open(item.link + `/${token}`, "_blank");
                  }}
                  onItemClick={(x) => navigate(x.url)}
                  onOpen={(item: any) => {
                    expandSidebar(true);
                    setShowItemMenu(item.id);
                  }}
                  extraStyle={{ color: "#424242", border: 0, gap: 24 }}
                  origin={{
                    color: "rgb(123, 123, 123)",
                    bgColor: "transparent",
                    img: item.img,
                  }}
                  hover={{
                    color: "#fff",
                    bgColor: "#1062D0",
                    img: item.imgHover,
                  }}
                  open={{
                    color: "#1062D0",
                    bgColor: "transparent",
                    img: item.imgActive,
                    open: isActive,
                  }}
                />
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default memo(Sidebar);

